/**
 * Jisp Retailer API v1.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Open360ShopperApiContractV18PaymentCardPaymentCardListItem {
    ID?: number;
    CardNumber?: string;
    /**
     * 1 = Visa, 2 = MasterCard
     */
    Type?: Open360ShopperApiContractV18PaymentCardPaymentCardListItem.TypeEnum;
    DisplayName?: string;
    _Default?: boolean;
    LastError?: string;
}
export namespace Open360ShopperApiContractV18PaymentCardPaymentCardListItem {
    export type TypeEnum = 1 | 2;
    export const TypeEnum = {
        NUMBER_1: 1 as TypeEnum,
        NUMBER_2: 2 as TypeEnum
    }
}



// WEBPACK FOOTER //
// ./src/app.retailer/modules/model/open360ShopperApiContractV18PaymentCardPaymentCardListItem.ts